import React, { useEffect, useMemo, useState } from 'react';
import { BreadCrumbs, DatePicker, formatters, SecondaryButton } from '../../../Core/Controls';
import { FormHelperText, Grid, InputLabel } from '@material-ui/core';
import { getFleetCheck__GetLastRunDate, getFleetCheckDefectsImportDefects } from '../../../Core/Services/InternalUser/ControllerService/customerService';
import GijgoGrid from '../../../Core/Controls/GijgoGrid';
import { useToast } from '../../../Core/Hooks/useToast';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Fleet Check Defects', active: true }
];

const basecolumns = [
    // { key: 'action', name: 'Action', width: '5%', addFileUploaderIcon: true },
    { key: 'regNo', name: 'Reg No', width: 70 },
    { key: 'defectDate', name: 'Date', formatter: formatters.Date_DDMMYYYY, width: 80 },
    { key: 'defectMileage', name: 'Mileage', width: 70 },
    { key: 'defectContactName', name: 'Contact Name', width: 150 },
    { key: 'defectDescription', name: 'Description', width: 200 },
    { key: 'defectRequiredDate', name: 'Required Date', formatter: formatters.Date_DDMMYYYY, width: 80 },
    { key: 'result', name: 'Result', width: 150 }
];

const FleetCheckDefects = (props) => {
    const { showToastSuccess, showToastError } = useToast();

    const [state, setState] = useState({
        date: '',
        lastRunDate: '',
        rows: []
    });

    const fetchLastRunDate = async (isDateSet = false) => {
        let res = await getFleetCheck__GetLastRunDate();

        if (res.success) {
            let formatedDate = res.data?.lastRunDate[0]?.fleetCheckLastRun ? formatters.DateFormatter(res.data?.lastRunDate[0]?.fleetCheckLastRun) : '';
            // setState((st) => ({
            //     ...st,
            //     date: formatedDate || '',
            //     lastRunDate: formatedDate || ''
            // }));

            setState((st) => {
                let newSt = { ...st };
                if (isDateSet) {
                    newSt.date = formatedDate || '';
                }
                newSt.lastRunDate = formatedDate || '';

                return newSt;
            });
        }
    };

    useEffect(async () => {
        await fetchLastRunDate(true);
    }, []);

    const inputChange = (event) => {
        const { name, value, checked } = event.target;

        setState((state) => ({
            ...state,
            [name]: value
        }));
    };

    const columns = useMemo(() => {
        const tempCols = [...basecolumns];
        // let actionCol = tempCols.find((e) => e.key === 'action');
        // if (actionCol) {
        //     actionCol.formatter = actionButton;
        // }
        return tempCols;
    }, []);

    const handleSubmit = async () => {
        console.log('Import clicked', props.customerID, state.date);
        // Import logic to be implemented
        const res = await getFleetCheckDefectsImportDefects(state.date, props.customerID);
        if (res.success) {
            // Handle successful import
            setState((state) => ({
                ...state,
                rows: res.data || []
            }));
            if (res.data.length > 0) {
                showToastSuccess('Import completed successfully');
            } else {
                showToastSuccess('No defects available to import');
            }
            await fetchLastRunDate(false);
        }

        if (res.message) {
            showToastSuccess(res.message || 'Import completed successfully');
        }
    };

    let dateLable = 'Date';
    if (state.lastRunDate) {
        dateLable = `Date (Last Run Date: ${state.lastRunDate})`;
    }

    return (
        <div className="screen">
            <Grid container spacing={2}>
                {/* <Grid item xs={12}>
                    <BreadCrumbs crumbs={crumbs} />
                </Grid> */}
                <Grid item xs={12}>
                    <Grid container spacing={2} alignItems="flex-end" alignContent="flex-end">
                        <Grid item xs={4}>
                            <DatePicker inputLabel={dateLable} placeholder="Date" name="date" value={state.date} onChange={inputChange} />
                        </Grid>
                        <Grid item xs={4}>
                            <SecondaryButton onClick={handleSubmit} fullWidth>
                                Import
                            </SecondaryButton>
                        </Grid>
                        <Grid item xs={4}>
                            <SecondaryButton onClick={() => props.onClose(false, false)} fullWidth>
                                cancel
                            </SecondaryButton>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <GijgoGrid
                        // dataConverter={(res) => ({
                        //     records: res.data.list,
                        //     total: res.data.total
                        // })}
                        columns={columns}
                        localRowsData={
                            state.rows
                            //     [
                            //     {
                            //         assetID: 1,
                            //         regNo: 'jhj897',
                            //         defectVehicleID: null,
                            //         defectDate: null,
                            //         defectReportingDepotID: null,
                            //         defectCustomerDefectNumber: '898',
                            //         defectMileage: '8',
                            //         defectContactName: null,
                            //         defectDescription: null,
                            //         defectRequiredDate: null,
                            //         defectFleetCheckDefectID: '112',
                            //         result: 'added recors'
                            //     }
                            // ]
                        }
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default FleetCheckDefects;
